import { memo, useEffect, useState } from 'react';
import { SpinnerLoader } from 'src/libraries';
import AccountService from 'src/services/account.service';
import ProvinceService from 'src/services/provice.service';
import { useAccount, useArea, useRefresh } from 'src/stores';
import { IBaseProps } from 'src/types';

const svProvince = new ProvinceService();
const svAccount = new AccountService();

function InitAppProvider({ children }: IBaseProps) {
  const [loading, setLoading] = useState<boolean>(false);
  const [init, setInit] = useState<boolean>(false);
  const { refresh } = useRefresh();
  const { changeListArea } = useArea();
  const { changeAccount } = useAccount();

  useEffect(() => {
    fetchInit();
  }, [refresh]);

  const fetchInit = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const account = await svAccount.profile();
      changeAccount(account);

      const area = await svProvince.getFull();
      changeListArea(area);

      setInit(true);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  if (loading || !init) return <SpinnerLoader bg={false} />;

  return children;
}

export default memo(InitAppProvider);
